import React from "react";

import { useDateRender } from "./useDateRender";

type DateDisplayProps = {
    date: string | Date;
};

export const DateDisplay = ({ date }: DateDisplayProps): JSX.Element => {
    const { renderDate } = useDateRender();

    return <>{renderDate(new Date(date))}</>;
};
